import { getRuntimeContext } from '../contexts/runtimeContext';
import { ViewContext } from '../types/errorTypes';

/**
 * Get current view context (route, modal, step, etc.)
 */
export function getViewContext(): ViewContext {
  const runtimeContext = getRuntimeContext();
  
  return {
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    modal: runtimeContext.modal ? {
      key: runtimeContext.modal.key || undefined,
      open: runtimeContext.modal.open || false,
    } : undefined,
  };
}

